<template>
<div class="SaleOne">
</div>
</template>

<script>
export default {
    name: 'SaleOne',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SaleOne {
}
</style>
